import { useUserStore } from '@/stores/useUserStore';
import { useAppStore } from '@/stores/useAppStore';
import { useToaster } from '@/../lib/utils/useToaster';
import axios from 'axios';

const axiosInstance = axios.create();

const token = localStorage.getItem('authToken');
if (token) {
  axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
}

axiosInstance.defaults.baseURL = process.env.VUE_APP_API_URL;

function extractErrorMessage(data) {
  if (data?.message) {
    return data.message;
  }

  if (data?.error) {
    return data.error;
  }

  return null;
}

axiosInstance.interceptors.response.use(
  (response) => {
    const data = response.data;

    // Case: success: true but exception present (RuntimeException etc.)
    if (data?.exception) {
      const message =
        extractErrorMessage(data) || 'An unexpected error occurred';
      const toaster = useToaster();
      toaster.error(message);

      const error = new Error(message);
      error.response = response;
      return Promise.reject(error);
    }

    // Case: success: false in response body
    if (data && data.success === false) {
      const message = extractErrorMessage(data);
      if (message) {
        const toaster = useToaster();
        toaster.error(message);
      }

      const error = new Error(message || 'Request failed');
      error.response = response;
      return Promise.reject(error);
    }

    return response;
  },
  (error) => {
    const userStore = useUserStore();

    if (error?.response?.status === 401) {
      userStore.logout();
      return Promise.reject(error);
    }

    if (error?.response?.status === 402) {
      const appStore = useAppStore();
      appStore.showModalLimitsVisible(true);
      return Promise.reject(error);
    }

    const message = extractErrorMessage(error.response?.data);
    if (message) {
      const toaster = useToaster();
      toaster.error(message);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
